import { LotteryModel } from 'v2/types/LotteryModel';

export type LotteryForm = Omit<LotteryModel, 'participants' | 'id'>;

export const initialValues: LotteryForm = {
  handledParticipants: [],
  realSlotsReferrals: [],
  verifiedParticipants: [],
  isActive: false,
};
